module.exports = __webpack_public_path__ + "static/media/Gotham-Medium.493a3897.woff";